
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPageLastGoogle as ObiPageLastGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-page-last-google.js';
 
 
 

 
 export const ObiPageLastGoogle = createComponent({
   react: React,
   tagName: 'obi-page-last-google',
   elementClass: ObiPageLastGoogleElement,
   events: {
     
   }
  });
 
 